import { apiUrl, authHeaders } from './auth';

export const fetchAgreement = async (campaign_id: number) => {
  const response = await fetch(
    `${apiUrl}/v2/campaign/agreement?campaign_id=${campaign_id}`,
    {
      headers: authHeaders(),
    }
  );
  const data = await response.json();
  return data;
};
